// extracted by mini-css-extract-plugin
module.exports = {"FormFooter":"FormFooter_FormFooter__2PwHk","FormFooter__left":"FormFooter_FormFooter__left__2K76e","FormFooter__right":"FormFooter_FormFooter__right__25MUg"};